import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TechnicalErrorComponent } from './technical-error/technical-error.component';

@NgModule({
  declarations: [
    TechnicalErrorComponent
  ],
  providers: [],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    TechnicalErrorComponent
  ]
})
export class ErrorsModule
{
}
